import { computed, useContext } from "@nuxtjs/composition-api";
import { useConfig } from "../useConfig";
function useMagentoConfiguration() {
  const {
    app: {
      $vsf: {
        $magento: { config }
      }
    }
  } = useContext();
  const { config: storeConfig } = useConfig();
  const selectedCurrency = computed(() => config.state.getCurrency());
  const selectedLocale = computed(() => config.state.getLocale());
  const selectedStore = computed(() => config.state.getStore());
  return {
    storeConfig,
    selectedCurrency,
    selectedLocale,
    selectedStore
  };
}
export * from "./UseMagentoConfiguration";
var useMagentoConfiguration_default = useMagentoConfiguration;
export {
  useMagentoConfiguration_default as default,
  useMagentoConfiguration
};
